import React from "react";
import "./pSecThree.scss";
import PhotoCaro from "../../component/PhotoCaro";
import { linkss, photoAlbum, sec2 } from "../../data/PhotoData";

function PhotoSecThree() {
  return (
    <div className="p-sec-three-container">
      <div className="p-sec-three-inn">
        <h2 className="p-sec-heading">{sec2.heading2}</h2>
        <p className="p-sec-des">{sec2.des4}</p>
        <div className="photo-team-grid">
          {photoAlbum.map((item, index) => (
            <div key={index}>
              <div className="photo-card">
                <img
                  src={item.image}
                  alt="Card cover"
                  className="photo-card-image"
                />
                <div className="photo-card-overlay">

                  <a href={item.url} target="_blank" rel="noopener noreferrer" className="photo-card-description">
                    See Album
                  </a>
                </div>
                <div className="title-cover">
                  {/* <h3 className="photo-card-title">{item.title}</h3> */}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="photo-btn-con">
          <a href={linkss.fbpage} target="_blank" rel="noopener noreferrer" className="photo-btn">See More Album</a>
        </div>
      </div>
    </div>
  );
}

export default PhotoSecThree;
